import React, { useEffect, useState } from 'react';
interface CountdownTimerProps {
  initialSeconds?: number;
  className?: string;
}
export function CountdownTimer({
  initialSeconds = 24 * 3600 + 47 * 60 + 32,
  className = ''
}: CountdownTimerProps) {
  const [secondsLeft, setSecondsLeft] = useState(initialSeconds);
  useEffect(() => {
    const interval = setInterval(() => {
      setSecondsLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const hours = Math.floor(secondsLeft / 3600);
  const minutes = Math.floor(secondsLeft % 3600 / 60);
  const seconds = secondsLeft % 60;
  const units = [{
    value: hours,
    label: 'Horas'
  }, {
    value: minutes,
    label: 'Min'
  }, {
    value: seconds,
    label: 'Seg'
  }];
  return <div className={`flex items-center justify-center gap-2 ${className}`} role="timer" aria-label="Tiempo restante de la oferta de lanzamiento" data-id="element-289" data-mp="1x6tbmkweht7d">
      {units.map((unit, i) => <React.Fragment key={unit.label} data-id="element-290" data-mp="3mooq03ycwyjx" data-mpi={i}>
          <div className="flex min-w-[60px] flex-col items-center rounded-lg bg-danger/10 px-3 py-2 sm:min-w-[72px]" data-id="element-291" data-mp="3mphlu9vs23na">
            <span className="font-heading text-2xl font-bold text-danger sm:text-3xl" data-id="element-292" data-mp="3hrg3jr66e8cv">
              {String(unit.value).padStart(2, '0')}
            </span>
            <span className="text-[10px] font-semibold uppercase tracking-wide text-danger/80" data-id="element-293" data-mp="3qps0eaxmy2dr">{unit.label}</span>
          </div>
          {i < units.length - 1 && <span className="text-xl font-bold text-danger sm:text-2xl" aria-hidden="true" data-id="element-294" data-mp="9ftrh88iv7f2">
              :
            </span>}
        </React.Fragment>)}
    </div>;
}